import styled from "styled-components";

export const StyledCopyButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  position: relative;

  .copy-button {
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0.5px solid;
    transition: all 0.3s ease;
    position: relative;

    &.short-link {
      background: linear-gradient(
        117.8deg,
        rgba(52, 199, 89, 0.3) 16.89%,
        rgba(52, 199, 89, 0.05) 84.91%
      );
      border-color: #34c759;
      box-shadow: 0px 4px 10px 0px #34c7594d;

      &.copied {
        background: linear-gradient(
          117.8deg,
          rgba(52, 199, 89, 0.6) 16.89%,
          rgba(52, 199, 89, 0.2) 84.91%
        );
        box-shadow: 0px 6px 15px 0px #34c7596d;
        transform: scale(1.05);
      }
    }

    &.long-link {
      background: linear-gradient(
        117.8deg,
        rgba(0, 122, 255, 0.3) 16.89%,
        rgba(0, 122, 255, 0.05) 84.91%
      );
      border-color: #007aff;
      box-shadow: 0px 4px 10px 0px #007aff4d;

      &.copied {
        background: linear-gradient(
          117.8deg,
          rgba(0, 122, 255, 0.6) 16.89%,
          rgba(0, 122, 255, 0.2) 84.91%
        );
        box-shadow: 0px 6px 15px 0px #007aff6d;
        transform: scale(1.05);
      }
    }

    &.loading {
      cursor: not-allowed;
      opacity: 0.7;
    }

    .loading-spinner {
      width: 16px;
      height: 16px;
      border: 2px solid #34c759;
      border-top: 2px solid transparent;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
